<script setup lang="ts">
import { Skeleton } from '@taler/ui'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <div class="flex flex-col gap-6">
    <p class="sr-only" role="status">{{ t('garage.loading') }}</p>
    <div aria-hidden="true" class="flex flex-col gap-6">
      <div class="flex items-center gap-3">
        <Skeleton width="14rem" height="2rem" />
        <Skeleton width="5rem" height="1.5rem" />
      </div>
      <div class="flex gap-4 border-b border-[color:var(--color-border)] pb-2">
        <Skeleton v-for="index in 4" :key="index" width="5.5rem" height="1rem" />
      </div>
      <div class="flex flex-col gap-4 sm:flex-row">
        <section
          class="flex flex-1 flex-col gap-4 rounded-[var(--radius-surface)] border border-[color:var(--color-border)] bg-[color:var(--color-surface)] p-4"
        >
          <Skeleton width="30%" height="1.25rem" />
          <Skeleton v-for="index in 3" :key="index" width="90%" height="1rem" />
        </section>
        <section
          class="flex flex-1 flex-col gap-3 rounded-[var(--radius-surface)] border border-[color:var(--color-border)] bg-[color:var(--color-surface)] p-4"
        >
          <Skeleton width="30%" height="1.25rem" />
          <div v-for="index in 4" :key="index" class="flex items-center justify-between gap-2">
            <Skeleton width="35%" height="1rem" />
            <Skeleton width="30%" height="1rem" />
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
